import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
    PAGE_THREATS, PAGE_OFFER, PAGE_ESTIMATION,
    PAGE_ABOUT, PAGE_CONTACT, PAGE_EBOOK, PAGE_WEBINAR
} from '../config/pages';

import Link from './helpers/Link';

const nextPage = (page) => {
    switch (page) {
        case PAGE_THREATS: return PAGE_OFFER;
        case PAGE_OFFER: return PAGE_ESTIMATION;
        case PAGE_ESTIMATION: return PAGE_ABOUT;
        case PAGE_ABOUT: return PAGE_CONTACT;
        default: return null;
    }
};

const prevPage = (page) => {
    switch (page) {
        case PAGE_CONTACT: return PAGE_ABOUT;
        case PAGE_ABOUT: return PAGE_ESTIMATION;
        case PAGE_ESTIMATION: return PAGE_OFFER;
        case PAGE_OFFER: return PAGE_THREATS;
        default: return null;
    }
};

class Switch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            localNoTransition: true
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ localNoTransition: false });
        }, 100);
    }

    render() {
        const { localNoTransition } = this.state;
        const {
            type, t, openPage, language, page, noTransition
        } = this.props;

        const newPage = (type === 'prev') ? prevPage(page) : nextPage(page);
        const className = cx('container-switch', `container-switch-${ type }`, 'has-transition', {
            show: newPage !== null,
            'no-transition': noTransition || ((page === PAGE_WEBINAR || page === PAGE_EBOOK) && localNoTransition)
        });
        return (
            <Link
              openPage={ openPage }
              language={ language }
              page={ newPage }
              className={ className }
              id={ className }
            >
                { newPage && t(`header.menu.${ newPage }`) }
            </Link>
        );
    }
}

Switch.propTypes = {
    type: PropTypes.oneOf(['prev', 'next']).isRequired,
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    noTransition: PropTypes.bool.isRequired
};

export default Switch;



// WEBPACK FOOTER //
// ./src/components/Switch.jsx